import './index.less';

import _ from 'lodash';
import commonMsg from 'messages';
import loginMsg from 'messages/Login';
import { Button, Checkbox, Divider, Icon, Input } from '@beehive/components';
import PropTypes from 'prop-types';
import React, { ChangeEvent } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { isBlank, ajax } from 'utils';
import Captcha from './Captcha';
import * as actions from 'modules/actions/account';
import { connect } from 'react-redux';
import { Dispatch, bindActionCreators } from 'redux';
import moment from 'moment';

import SupplierChoose from './SupplierChoose';
import { encryptPassword } from 'utils/encryptPassword';
import { REPORT_URL } from '@mpc/common/src/utils/CONST';
import { getOuterTitle, isOuterIpService } from '@mpc/common/src/utils';

const messages = { ...commonMsg, ...loginMsg };
export interface LoginProps extends RouteComponentProps {
  prefixCls?: string;
  userLogin: Function;
  getUserInfo: Function;
  suppliersList: Array<Record<string, any>>;
}

class Login extends React.Component<LoginProps, any> {
  private refreshRef: any;
  public static contextTypes = {
    intl: PropTypes.object,
  };
  public static defaultProps = {
    prefixCls: 'mpc-external-login',
  };
  constructor(props: LoginProps) {
    super(props);
    this.state = {
      showSupplierModal: false,
      loading: false,
    };
  }
  public handleForgetPwd = () => {
    const { history } = this.props;
    history.push('/forget');
  }
  public handleLogin = () => {
    const { intl } = this.context;
    const { userLogin, getUserInfo, history } = this.props;
    const { account, password, verifyCode } = this.state;
    const alertMsg = this.getAlertMsg();
    if (alertMsg) {
      return;
    }
    const body = {
      login: account,
      password: encryptPassword(password),
      _rucaptcha: verifyCode,
      encrypted: true,
    };
    this.setState({
      loading: true,
    });
    userLogin(body).then((res: any) => {
      if (res.res_code === 1) {
        // 获取账户供应商列表，大于1 则需要弹框选择, 其余情况照旧;
        const { suppliersList } = this.props;
        if (suppliersList.length > 1) {
          this.setState({
            showSupplierModal: true,
          });
        } else {
          getUserInfo({});
          history.push('/');
        }
        this.setState({
          loading: false,
        });
      } else if (res.res_code === 0) {
        this.refreshRef({
          locale: intl.locale,
          onChange: this.handleChange,
        });
        this.setState({ alertMsg: res.res_msg, verifyCode: null, loading: false });
      }
    }).catch(() => {
      this.setState({
        loading: false,
      });
    });
  }
  public handleChange = (newVal: { [key: string]: any }) => {
    const { errorKey, alertMsg } = this.state;
    let newErrorKey = errorKey;
    let newAlertMsg = alertMsg;
    if (!!~Object.keys(newVal).indexOf(errorKey)) {
      newErrorKey = null;
      newAlertMsg = null;
    }
    const val = {
      ...this.state,
      ...newVal,
      errorKey: newErrorKey,
      alertMsg: newAlertMsg,
    };
    this.setState(val);
  }
  public getAlertMsg = () => {
    const { intl } = this.context;
    const { account, password, verifyCode } = this.state;
    let alertMsg = null;
    let errorKey = null;
    switch (true) {
      case isBlank(account): {
        alertMsg = intl.formatMessage(messages.accountAlertMsg);
        errorKey = 'account';
        break;
      }
      case isBlank(password): {
        alertMsg = intl.formatMessage(messages.pwdPlaceholder);
        errorKey = 'password';
        break;
      }
      case isBlank(verifyCode): {
        alertMsg = intl.formatMessage(messages.captchaAlertMsg);
        errorKey = 'verifyCode';
        break;
      }
      default: {
        //
      }
    }
    this.setState({ alertMsg, errorKey });
    return alertMsg;
  }
  getRefreshRef = (refresh: any) => {
    this.refreshRef = refresh;
  }
  downloadHelp = () => {
    ajax({
      url: 'outsource/download?cate=help',
      method: 'POST',
      dataType: 'blob',
    });
  }

  public render() {
    const { intl } = this.context;
    const { prefixCls } = this.props;
    const { account, password, noneedLogin, alertMsg, errorKey, showSupplierModal, loading } = this.state;
    return (
      <div className={`${prefixCls} ${prefixCls}-wrap`}>
        <div className={`${prefixCls}-copyright`}>
          {`Copyright 2017-${moment().year()} NetEase Inc All Rights Reserved`}
          <a
            className={`${prefixCls}-copyright-icp`}
            href="http://www.beian.miit.gov.cn"
            target="_blank"
            rel="noopener noreferrer"
          >
            ICP备案：粤B2-20090191-2
          </a>
        </div>
        <div className={`${prefixCls} ${prefixCls}-title`}>
          {getOuterTitle()}
        </div>
        <div className={`${prefixCls} ${prefixCls}-picture`} />
        <div className={`${prefixCls} ${prefixCls}-form`}>
          <Input
            className={`${prefixCls}-form-item user-name ${
              errorKey === 'account' ? 'show-error' : ''
            }`}
            placeholder={intl.formatMessage(messages.accountPlaceholder)}
            prefix={<Icon name="user-o" />}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              this.handleChange({ account: e.target.value })
            }
            value={account}
          />
          <Input
            className={`${prefixCls}-form-item user-pwd ${
              errorKey === 'password' ? 'show-error' : ''
            }`}
            type="password"
            placeholder={intl.formatMessage(messages.pwdPlaceholder)}
            prefix={<Icon name="lock-o" />}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              this.handleChange({ password: e.target.value })
            }
            value={password}
          />
          <Captcha
            locale={intl.locale}
            onChange={this.handleChange}
            getRefreshRef={this.getRefreshRef}
          />
          <div className={`${prefixCls}-options`}>
            <Checkbox
              checked={noneedLogin}
              onClick={() => this.handleChange({ noneedLogin: !noneedLogin })}
            >
              {intl.formatMessage(messages.noNeedLoginMsg)}
            </Checkbox>
            {!isOuterIpService() && (
              <Button link onClick={this.handleForgetPwd}>
                {`${intl.formatMessage(messages.forgetPwd)}
                  ${intl.formatMessage(messages.questionMark)}
                `}
              </Button>
            )}
          </div>
          <div className={`${prefixCls}-alert-msg`}>
            {alertMsg && <Icon name="exclamation-circle-o" />}
            {alertMsg}
          </div>
          <Button
            type="primary"
            className={`${prefixCls}-login-btn`}
            onClick={this.handleLogin}
            loading={loading}
          >
            {intl.formatMessage(messages.loginBtnMsg)}
          </Button>
          <div className={`${prefixCls}-footer`}>
            <Button link onClick={this.downloadHelp}>{intl.formatMessage(messages.helpDocument)}</Button>
            <Divider vertical />
            <Button link>{intl.formatMessage(messages.contactUsMsg)}</Button>
            <Divider vertical />
            <Button link onClick={() => window.open(REPORT_URL)}>廉正举报</Button>
          </div>
        </div>
        <SupplierChoose
          visible={showSupplierModal}
          onChangeVisible={(v: boolean) =>
            this.setState({
              showSupplierModal: v,
            })
          }
          showClose={false}
        />
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return { suppliersList: state.account.suppliersList};
};

export function mapDispatchToProps(dispatch: Dispatch<actions.AccountActions>) {
  return bindActionCreators(
    {
      userLogin: actions.userLogin,
      getUserInfo: actions.getUserInfo,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);
